<template>
    <div class="card-body2">
        <div class="list-containerbox">
            <!--Shipping-->

            <div class="shiping-details">
                
                <template v-if="shipmentDetails.milestones.length > 0 || shipmentDetails.upcoming_milestone.length > 0">
                <div class="flex-shrink-0 mt-sm-0 mt-3 fwefsa">
                    <div class="vertical-progress">
                        <div class="profile-timeline">
                            <div class="accordion accordion-flush">
                                <template v-for="(item, index) in shipmentDetails.milestones">
                                
                                    
                                    <div class="accordion-item border-0">
                                        <div class="accordion-header">
                                            <a class="accordion-button p-0 shadow-none">
                                                <div class="d-flex align-items-center">
                                                    <div class="flex-shrink-0 avatar-xs">
                                                        <div class="avatar-title bg-info rounded-circle">
                                                            <i class="ri-file-list-line"></i>
                                                        </div>
                                                    </div>
                                                    <div class="flex-grow-1 ms-2">
                                                        <h6 class="fs-14 mb-0 fw-medium text-info">{{ item.title }}</h6>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                        <template v-if="item.data">
                                            <template v-for="(additional,index) in item.data">
                                                <div class="accordion-body ms-2 ps-32 pe-0 pt-0">
                                                <p class="color-h mb-2">{{ additional.title }}</p>
                                                <p class="text-muted text-italic mb-2">{{ additional.timestamp }}</p>
                                                
                                            </div>
                                            </template>
                                            
                                        </template>
                                        <template v-else>
                                            <template v-if="item.timestamp != null">
                                                <div id="collapseOne" class="accordion-collapse collapse show">
                                                <div class="accordion-body ms-2 ps-32 pe-0 pt-0">
                                                    <p class="text-muted text-italic mb-0">{{ item.timestamp }}</p>
                                                </div>
                                            </div>
                                            </template>
                                            <template v-else>
                                                <br>
                                            </template>
                                            
                                        </template>
                                        
                                        

                                    </div>
                                    
                                </template>   

                                <template v-for="(item, index) in shipmentDetails.upcoming_milestone">
                                
                                    
                                    <div class="accordion-item border-0">
                                        <div class="accordion-header">
                                            <a class="accordion-button p-0 shadow-none">
                                                <div class="d-flex align-items-center">
                                                    <div class="flex-shrink-0 avatar-xs">
                                                        <div class="avatar-title bg-info rounded-circle">
                                                            <i class="ri-file-list-line"></i>
                                                        </div>
                                                    </div>
                                                    <div class="flex-grow-1 ms-2">
                                                        <h6 class="fs-14 mb-0 fw-medium text-info">{{ item.title }}</h6>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                        <template v-if="item.data">
                                            <template v-for="(additional,index) in item.data">
                                                <div class="accordion-body ms-2 ps-32 pe-0 pt-0">
                                                <p class="color-h mb-2">{{ additional.title }}</p>
                                                <p class="text-muted text-italic mb-2">{{ additional.timestamp }}</p>
                                                
                                            </div>
                                            </template>
                                            
                                        </template>
                                        <template v-else>
                                            <template v-if="item.timestamp != null">
                                                <div id="collapseOne" class="accordion-collapse collapse show">
                                                <div class="accordion-body ms-2 ps-32 pe-0 pt-0">
                                                    <p class="text-muted text-italic mb-0">{{ item.timestamp }}</p>
                                                </div>
                                            </div>
                                            </template>
                                            <template v-else>
                                                <br>
                                            </template>
                                            
                                        </template>
                                        
                                        

                                    </div>
                                    
                                </template> 

                            </div>
                           
                        </div>
                    </div>  
                </div>
                </template>

            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import { mapActions, mapGetters, mapState } from "vuex";
import Vue from "vue";

export default {
    name: "OrderShipping",
    props: ["order", "loading", "isEditMode", "shipmentDetails"],
    mounted() {
        // this.syncLatestData();
    },
    data() {
        return {
            shipSearch: null,
            shippingForm: {
                is_stocking: 0,
                stocking_terms: null,
                warehouses: [],
                customerWarehouses: [],
                billTo: [],
            },
            warehouses: [],
            customerWarehouses: [],
        };
    },
    methods: {
        ...mapActions([
            "setCommonErrors",
            "setErrorMessage",
            "setSuccessMessage",
            "setLoading",
        ]),
        addWarehouse() {
            this.shippingForm.warehouses.push({
                id: null,
                warehouse_id: null,
                address: null,
            });
        },
        removeWarehouse(warehouse, index) {
            if (warehouse.id) {
                this.deleteWarehouse(warehouse.id, "superb");
            } else {
                this.shippingForm.warehouses.splice(index, 1);
            }
        },
        addCustomerWarehouse() {
            this.shippingForm.customerWarehouses.push({
                id: null,
                warehouse_id: null,
                address: null,
            });
        },
        removeCustomerWarehouse(warehouse, index) {
            if (warehouse.id) {
                this.deleteWarehouse(warehouse.id, "customer");
            } else {
                this.shippingForm.customerWarehouses.splice(index, 1);
            }
        },
        addBillTo() {
            this.shippingForm.billTo.push({
                id: null,
                warehouse_id: null,
                address: null,
            });
        },
        removeBillTo(warehouse, index) {
            if (warehouse.id) {
                this.deleteWarehouse(warehouse.id, "customer", true);
            } else {
                this.shippingForm.billTo.splice(index, 1);
            }
        },
        getWarehouses(is_customer = 0) {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            let url = window.route("getWarehouses");
            if (is_customer) {
                if (this.order.customer) {
                    url = window.route("getWarehouses", {
                        customer_id: this.order.customer.id,
                    });
                } else {
                    return;
                }
            }
            return axios
                .get(url, {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    },
                })
                .then(({ data }) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        if (is_customer) {
                            this.customerWarehouses = data.data;
                            let defaultWarehouses =
                                this.customerWarehouses.filter(
                                    (x) => x.is_default
                                );
                            if (
                                defaultWarehouses.length &&
                                (this.shippingForm.customerWarehouses[0]
                                    .address == null ||
                                    this.shippingForm.customerWarehouses[0]
                                        .address == "") &&
                                this.shippingForm.customerWarehouses[0]
                                    .warehouse_id == null
                            ) {
                                this.shippingForm.customerWarehouses[0].warehouse_id =
                                    defaultWarehouses[0].id;
                            }
                        } else {
                            this.warehouses = data.data;
                        }
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        saveShippingData() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .post(
                    window.route("so.updateOrderShippingData", {
                        id: this.order.id,
                    }),
                    this.shippingForm,
                    {
                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        },
                    }
                )
                .then(({ data }) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        self.$emit("updatedShippingEvent");
                        //self.isEditMode = false;
                        /*self.customerForm = {
                            customer: null,
                            customer_id: null,
                        };*/
                        self.setSuccessMessage("Order saved successfully");
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        deleteWarehouse(id, type = "customer", isBill = false) {
            let self = this;
            Vue.$confirm({
                title: "Are you sure?",
                message: "Are you sure you want to delete?",
                button: {
                    yes: "Yes",
                    no: "Cancel",
                },
                callback: (confirm) => {
                    if (confirm) {
                        self.setLoading(true);
                        self.setCommonErrors([]);
                        self.setErrorMessage(null);
                        return axios
                            .delete(
                                window.route("orders.warehouses.destroy", {
                                    id: self.order.id,
                                    warehouse_id: id,
                                }),
                                {
                                    validateStatus: function (status) {
                                        return status < 500; // Resolve only if the status code is less than 500
                                    },
                                }
                            )
                            .then(({ data }) => {
                                if (data.errorMessage) {
                                    self.setErrorMessage(data.errorMessage);
                                    if (data.errors) {
                                        self.setCommonErrors(data.errors);
                                    }
                                } else {
                                    self.$emit("updatedShippingEvent");
                                    self.setSuccessMessage(
                                        "Warehouse deleted from order!"
                                    );
                                    if (type === "customer") {
                                        if (isBill) {
                                            self.order.products.splice(
                                                self.shippingForm.billTo.indexOf(
                                                    (x) => x.id == id
                                                ),
                                                1
                                            );
                                        } else {
                                            self.order.products.splice(
                                                self.shippingForm.customerWarehouses.indexOf(
                                                    (x) => x.id == id
                                                ),
                                                1
                                            );
                                        }
                                    } else {
                                        self.order.products.splice(
                                            self.shippingForm.warehouses.indexOf(
                                                (x) => x.id == id
                                            ),
                                            1
                                        );
                                    }
                                    setTimeout(() => {
                                        self.setSuccessMessage(null);
                                    }, 5000);
                                }
                            })
                            .catch((error) => {
                                self.setErrorMessage(
                                    error.response &&
                                        error.response.errorMessage
                                        ? error.response.errorMessage
                                        : error.message
                                );
                            })
                            .finally(() => {
                                self.setLoading(false);
                            });
                    }
                },
            });
        },
        syncLatestData() {
            //this.shippingForm.is_stocking = this.order.is_stocking;
            // this.shippingForm.stocking_terms = this.order.stocking_terms;
            this.shippingForm.warehouses = _.cloneDeep(this.order.warehouses);
            this.shippingForm.customerWarehouses = _.cloneDeep(
                this.order.customer_warehouses
            );
            this.shippingForm.billTo = _.cloneDeep(this.order.bill_warehouses);

            if (
                this.order.customer_warehouses &&
                this.order.customer_warehouses.length == 0
            ) {
                this.shippingForm.customerWarehouses = [
                    {
                        id: null,
                        warehouse_id: null,
                        address: null,
                    },
                ];
            }

            if (
                this.order.bill_warehouses &&
                this.order.bill_warehouses.length == 0
            ) {
                this.shippingForm.billTo = [
                    {
                        id: null,
                        warehouse_id: null,
                        address: null,
                    },
                ];
            }
        },
    },
    computed: {
        ...mapState(["salesOrderState"]),
        ...mapGetters(["maxNumOfShipToAddress"]),
    },
    watch: {
        "shippingForm.is_stocking": {
            handler: function (after, before) {
                if (after == 1) {
                    this.shippingForm.warehouses = [
                        {
                            id: null,
                            warehouse_id: null,
                            address: null,
                        },
                    ];

                    if (this.warehouses.length) {
                        let defaultWarehouses = this.warehouses.filter(
                            (x) => x.is_default
                        );
                        if (defaultWarehouses.length) {
                            this.shippingForm.warehouses[0].warehouse_id =
                                defaultWarehouses[0].id;
                        }
                    }
                } else {
                    this.shippingForm.warehouses = [];
                }
            },
        },
        order: {
            handler: function (after, before) {
                this.syncLatestData();
            },
        },
    },
};
</script>

<style scoped></style>
